import 'bootstrap/dist/css/bootstrap.min.css';
import DashboardNavbar from '../../Components/DashboardNavbar/DashboardNavbar';
import Games from '../../Components/Games/Games';
import Call from '../../Components/Call/Call';
import './Dashboard.scss';
import {useContext, useEffect} from "react";
import AuthContext from "../../Store/auth-context";
import axios from "axios";

function Dashboard() {
    // const { setRoleStatus ,login} = useContext(AuthContext);
    // const email = localStorage.getItem("email");
    // console.log(email);
    //
    //
    // useEffect(()=>{
    //     function Data(){
    //         try{
    //             axios.post("https://stripe-node-vx6pg.ondigitalocean.app/redirect",{email_address:email})
    //                 // axios.post("http://localhost:8000/redirect",{email_address:email})
    //                 .then(response=>{
    //                     if(response.data !==[] && response.data[0] !== undefined ){
    //                         if(response.data[0].is_active){
    //                             login("loggedin");
    //                             setRoleStatus(response.data[0].is_active)
    //                         }
    //                     }
    //                 })
    //         } catch (err){
    //             console.log(err.message)
    //         }
    //     }
    //     Data();
    //
    // })
  return (
    <div id='dashboard'>
        <div className='dashboardContainer'>
            <DashboardNavbar />
            <Call />
            <Games />
        </div>
    </div>
  );
}

export default Dashboard;
